import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../../csi/middleware/customView/CustomViewDialogStore";
import SizeChartTableCustomViewOptionsStore from "./SizeChartTableCustomViewOptionsStore";
import SizeChartTableOptions from "./SizeChartTableOptions";

const SizeChartTableViewOptions: FunctionComponent = observer(function SizeChartTableViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as SizeChartTableCustomViewOptionsStore;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewSpecificOptionsCollapse}
			dataCsiAutomation="SizeChartTableViewOptions"
			onCollapse={toggleCollapsedViewSpecificOptions}
			titleRes="CustomViewSizeChartOptions"
		>
			<SizeChartTableOptions />
		</CustomViewOptionCustomSection>
	);
});

export default SizeChartTableViewOptions;